// The backend attaches a switch to its UOS panel by name, so the name a panel
// is saved under has to be the one built for that panel.
//
// UOSName is indexed by panel number - 1 (SystemIdentification.js builds one
// entry per panel, 01..numOfUOS), while the payload builders group switches by
// UOS and drop panels that hold none. Indexing the name array by position in
// that grouped list therefore names a panel after an earlier one as soon as any
// panel is empty. Look the name up by the panel's own number instead.
//
// An empty panel reduces to [] rather than '', which is truthy and has no
// .toUpperCase() — hence the explicit string check rather than a falsy test.
export const panelDeviceName = (UOSName, uosNumber) => {
  const entry = (UOSName ?? [])[Number(uosNumber) - 1];

  // Each entry is stored with a leading '/' separator, which is not part of
  // the name. slice(1) matches what the callers did before.
  return typeof entry === 'string' ? entry.slice(1) : '';
};

